import React, { useContext } from "react";
import GlobalContext from "contexts/GlobalContext";
//import CMSContentWrapper from "./CMSContentWrapper";
import "./CMSContent.scss";
import { CMSContentWrapper } from "@sia/style-guide";
import { useHistory } from "react-router-dom";
import cmsAdapter from "common/Adapters/CMSAdapter/CMSAdapter";

const CMSContent = ({ nodeId, isHash, isOrgaHomePage }) => {
  const { language: languageKey, menuItems, noMenuPages } = useContext(GlobalContext);
  const { organizationCode, organisationData } = useContext(GlobalContext);
  const history = useHistory();

  return (
    <div className="cms-content">
      {languageKey && (
        <CMSContentWrapper
          nodeId={nodeId}
          isHash={isHash}
          isOrgaHomePage={isOrgaHomePage}
          languageKey={languageKey}
          menuItems={menuItems}
          noMenuPages={noMenuPages}
          organizationCode={organizationCode}
          organisationData={organisationData}
          history={history}
          cmsAdapter={cmsAdapter}

        />
      )}
    </div>
  );
};

export default CMSContent;
